import React from "react";
import { Outlet } from "react-router";
import Box from "@mui/material/Box";
import { getUser, getUserTypes } from "../../../../API/swesum";

export function User() {
  return (
    <Box component="main" sx={{ flexGrow: 1 }}>
      <Outlet />
    </Box>
  );
}
